import React, { useState } from 'react';
import { getAgentImageUrl, getAgentImageFallbackUrl } from '../services/agentImageService';
import GradientCardImage from './GradientCardImage';

const AgentCard = ({ agent, onSelect, domainColor, isActive, onUse, onDeactivate, onEdit }) => {
  const primary = getAgentImageUrl(agent.name);
  const backup  = getAgentImageFallbackUrl(agent.name);
  const [src, setSrc]               = useState(primary);
  const [showGradient, setShowGradient] = useState(false);

  const handleError = () => {
    if (src === primary) setSrc(backup);
    else setShowGradient(true);
  };

  return (
    <div
      className="group bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-200 cursor-pointer flex flex-row overflow-hidden min-h-[108px]"
      onClick={() => onSelect('agent', agent)}
    >
      {/* Image strip — fills full card height */}
      <div className="w-28 flex-shrink-0 relative overflow-hidden bg-gray-100 self-stretch">
        {showGradient ? (
          <GradientCardImage name={agent.name} />
        ) : (
          <img
            src={src}
            alt={agent.name}
            className="absolute inset-0 w-full h-full object-cover saturate-50 group-hover:saturate-100 transition-all duration-300"
            onError={handleError}
          />
        )}
        <div className="absolute inset-0 bg-primary/20" />
      </div>

      {/* Content */}
      <div className="flex flex-col flex-grow min-w-0 p-3 gap-1">
        <h3 className="text-sm font-bold text-gray-900 line-clamp-2 leading-snug">
          {agent.name}
        </h3>
        <p className="text-xs text-gray-500 line-clamp-2 leading-relaxed flex-grow">
          {agent.description || 'No description available'}
        </p>
        <div className="flex items-center justify-between pt-1.5">
          <span className="text-[10px] text-gray-400 truncate">
            {agent.publisher && agent.publisher !== 'Internal' ? agent.publisher : agent.version || ''}
          </span>
          <div className="flex items-center gap-1.5">
            {onEdit && (
              <button
                onClick={e => { e.stopPropagation(); onEdit(agent); }}
                className="opacity-0 group-hover:opacity-100 transition-opacity duration-150 p-1 rounded-lg border border-gray-200 text-gray-400 hover:text-gray-600 hover:border-gray-300"
                title="Edit agent"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </button>
            )}
            {isActive ? (
              <button
                className="inline-flex items-center gap-0.5 text-[10px] font-semibold bg-green-100 text-green-700 border border-green-400 hover:bg-red-50 hover:text-red-600 hover:border-red-400 px-2 py-0.5 rounded-full whitespace-nowrap transition-colors duration-150"
                onClick={e => { e.stopPropagation(); onDeactivate && onDeactivate(agent); }}
                title="Click to deactivate"
              >
                <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                </svg>
                Active
              </button>
            ) : (
              <button
                className="text-xs font-semibold border border-primary/70 text-primary hover:bg-primary hover:text-white hover:border-primary px-3 py-0.5 rounded-full transition-colors duration-150 whitespace-nowrap"
                onClick={e => { e.stopPropagation(); onUse && onUse(agent); }}
              >
                Activate
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentCard;
